import React from "react";
import { Row, Col, Button, Form, Space } from "antd";
import { useForm } from "react-hook-form";
import { DateField, InputField } from "../../../atoms/FormElement";
import { datePlaceholderddmmyyFormat } from "../../BookingForm/components/utils";

export default React.memo((props: any) => {
  const {
    control,
    handleSubmit,
    formState: { errors },
    reset,
    setValue,
    getValues,
    setError,
    clearErrors,
  } = useForm({});

  const {
    startDateFrom,
    setStartDateFrom,
    startDateTo,
    setStartDateTo,
    setVactingDateFrom,
    vactingDateFrom,
    vactingDateTo,
    setVactingDateTo,
    endDateFrom,
    setEndDateFrom,
    setEndDateTo,
    endDateTo,
    filterReset,
  } = props;

  const onFilterSubmit = (e) => {
    setStartDateFrom(e?.startDateFrom === "" ? null : e?.startDateFrom);
    setStartDateTo(e?.startDateTo === "" ? null : e?.startDateTo);
    setVactingDateFrom(e?.vactingDateFrom === "" ? null : e?.vactingDateFrom);
    setVactingDateTo(e?.vactingDateTo === "" ? null : e?.vactingDateTo);
    setEndDateFrom(e?.endDateFrom === "" ? null : e?.endDateFrom);
    setEndDateTo(e?.endDateTo === "" ? null : e?.endDateTo);
  };

  const resetAllFields = () => {
    setValue("startDateFrom", null);
    setValue("startDateTo", null);
    setValue("vactingDateFrom", null);
    setValue("vactingDateTo", null);
    setValue("endDateFrom", null);
    setValue("endDateTo", null);
    filterReset();
  };

  return (
    <Form layout="vertical" className="bf-main" onFinish={handleSubmit((e) => onFilterSubmit(e))}>
      <Row gutter={6}>
        <Col span={12}>
          <DateField
            control={control}
            setValue={setValue}
            label="Start Date From"
            fieldname="startDateFrom"
            iProps={{
              format: datePlaceholderddmmyyFormat,
              placeholder: "Start Date From",
            }}
            valueGot={startDateFrom}
          />
        </Col>

        <Col span={12}>
          <DateField
            control={control}
            setValue={setValue}
            label="Start Date To"
            fieldname="startDateTo"
            iProps={{
              format: datePlaceholderddmmyyFormat,
              placeholder: "Start Date To",
            }}
            valueGot={startDateTo}
          />
        </Col>

        <Col span={12}>
          <DateField
            control={control}
            setValue={setValue}
            label="End Date From"
            fieldname="endDateFrom"
            iProps={{
              format: datePlaceholderddmmyyFormat,
              placeholder: "End Date From",
            }}
            valueGot={endDateFrom}
          />
        </Col>

        <Col span={12}>
          <DateField
            control={control}
            setValue={setValue}
            label="End Date To"
            fieldname="endDateTo"
            iProps={{
              format: datePlaceholderddmmyyFormat,
              placeholder: "End Date To",
            }}
            valueGot={endDateTo}
          />
        </Col>

        <Col span={12}>
          <DateField
            control={control}
            setValue={setValue}
            label="Vacating Date From"
            fieldname="vactingDateFrom"
            iProps={{
              format: datePlaceholderddmmyyFormat,
              placeholder: "Vacating Date From",
            }}
            valueGot={vactingDateFrom}
          />
        </Col>

        <Col span={12}>
          <DateField
            control={control}
            setValue={setValue}
            label="Vacating Date To"
            fieldname="vactingDateTo"
            iProps={{
              format: datePlaceholderddmmyyFormat,
              placeholder: "Vacating Date To",
            }}
            valueGot={vactingDateTo}
          />
        </Col>

        <Col span={24}>
          <Space style={{ position: "fixed", bottom: "10px", right: "5px" }}>
            <Button size={"small"} style={{ marginTop: "10px" }} className="ef-approve-btn" htmlType="submit">
              {"Submit"}
            </Button>

            <Button
              size={"small"}
              style={{ marginTop: "10px" }}
              onClick={() => resetAllFields()}
              className="ef-reject-btn"
              htmlType="button"
            >
              {"Reset"}
            </Button>
          </Space>
        </Col>
      </Row>
    </Form>
  );
});
